import React, { useEffect } from "react";
import CTABtnModule from "../../../modules/cta_btn_module";


const BannerBtn = ({banner_section}) => {


  return (

    <>
        {(banner_section?.button_cta_1?.label || banner_section?.button_cta_2?.label) && 
        <div className="btn-wrapper">
            {banner_section?.button_cta_1?.label && 
            <CTABtnModule button_cta={banner_section?.button_cta_1}/>
            }

            {banner_section?.button_cta_2?.label && 
            <CTABtnModule button_cta={banner_section?.button_cta_2}/>
            }
        </div>
        }
    </>

  );
};
export default BannerBtn;
